import { render, staticRenderFns } from "./api-section.vue?vue&type=template&id=846c0954&"
import script from "./api-section.vue?vue&type=script&lang=js&"
export * from "./api-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports